<template>
  <div>
    <b-tabs v-model="activeTab" position="is-left">
      <b-tab-item label="Compose">
        <div v-if="visiblePage === 'Compose'">
          <MessageComposer
            message=""
            :finalizeMessage="finalizeMessage"
            :showPreview="true"
            :showSendTestEmail="true"
            :showAttachments="true"
            :processPreview="processFinalPreview"
            :processSendTestEmail="processSendTestEmail"
            :processAttachments="processAttachments"
            :composedText="emailMessage"
            :composedSubject="emailSubject"
            :handleImageAdded="handleImageAdded"
            :handleImageRemoved="handleImageRemoved"
            :isReadOnly="isReadOnly"
          />
        </div>
      </b-tab-item>
      <b-tab-item label="Preview">
        <div v-if="visiblePage === 'FinalPreview'">
          <div class="force-center subtitle pb-5">
            File Preview
          </div>
          <div
            class="pb-5"
            style="text-align: left !important;"
            v-if="typeof (composedSubject === 'string')"
            v-html="composedSubject"
          ></div>
          <div
            class="pb-5"
            style="text-align: left !important;"
            v-if="typeof (composedText === 'string')"
            v-html="composedText"
          ></div>
        </div>
      </b-tab-item>
      <b-tab-item label="Attachments">
        <div v-if="visiblePage === 'EmailAttachments'">
          <div class="force-center subtitle pb-5">
            Email Attachment Documents
          </div>

          <div class="column is-12">
            <section class="pt-6 violation-image-upload">
              <b-field class="file">
                <b-upload
                  v-model="files"
                  multiple
                  drag-drop
                  accept="application/pdf"
                  class="rectangle"
                >
                  <section class="force-center float-center">
                    <div class="force-center float-center">
                      <div class="force-center float-center" style="padding-left: 166px">
                        <img
                          class="Fill-1-Copy-11 force-center float-center"
                          src="@/assets/images/fill-1-copy-11.svg"
                          alt="Upload"
                        />
                      </div>
                      <div class="force-center float-center">
                        <div class="Drag-Drop-your-fil">
                          <div class="text-style-1">Drag & Drop</div>
                          <div class="force-center float-center">
                            Drop your PDF files here or click to upload.
                          </div>
                          <div class="force-center float-center">
                            Select one or more files from your computer.
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </b-upload>
              </b-field>

              <ul id="gallery" class="flex flex-1 flex-wrap -m-1">
                <li
                  v-show="previews !== undefined && !previews.length"
                  class="h-full w-full text-center flex flex-col items-center justify-center items-center"
                >
                  <img
                    class="mx-auto w-32"
                    src="https://user-images.githubusercontent.com/507615/54591670-ac0a0180-4a65-11e9-846c-e55ffce0fe7b.png"
                    alt="no data"
                  />
                  <span class="text-small text-gray-500">No files selected</span>
                </li>
                <li v-for="(image, index) in previews" :key="index" class="p-1 flex w-1/4 h-32">
                  <div
                    class="align-items-center relative w-full h-full bg-cover"
                    :style="`background-image: url(${image});`"
                  >
                    <button class="delete is-small" type="button" @click="deleteDropFile(index)" />
                    <label class="absolute inset-x-0 bottom-0 bg-black bg-opacity-50 z-10 p-2">
                      <span style="color:white;">{{ files[index].name }}</span>
                    </label>
                  </div>
                </li>
              </ul>
            </section>
          </div>

          <span>
            <figure
              v-for="(doc, dindex) in documents"
              :key="dindex"
              vio-photo
              tabindex="0"
              :aria-label="'photo ' + (dindex + 1)"
              :style="{
                position: 'relative',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',

                margin: '4px',

                height: '140px',
                width: '140px',

                overflow: 'hidden',
                borderRadius: '6px',

                boxShadow: '0 12px 18px 0 rgba(0, 0, 0, 0.25)'
              }"
              @click.prevent="openPDFModal(doc.id)"
            >
              <transition name="fade">
                <PDFTile
                  v-if="documents[dindex]"
                  :src="documents[dindex].content"
                  :style="{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translateX(-50%) translateY(-50%)',
                    flexShrink: '0',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    height: '100%',
                    width: '100%',
                    objectFit: 'contain',

                    cursor: 'pointer'
                  }"
                />
              </transition>
            </figure>
          </span>

          <PDFModal ref="pdfModal" />

          <div>
            <b-button type="is-primary" @click.prevent="saveAttachments">Add Attachment(s)</b-button
            >&nbsp;&nbsp;&nbsp;
            <b-button type="is-primary" @click.prevent="deleteConfirmation"
              >Delete Attachments</b-button
            >
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import MessageComposer from '../keys/MessageComposer'
import { mapState, mapGetters } from 'vuex'
import { notifyMessage, notifyError, notifyProblem } from '@/services/notify'
import { mailingCommunicationStore } from '@/services/MailingCommunications/store'
import { KMS_BACKEND } from '@/config'
import PDFModal from '@/components/Modals/PDF'
import PDFTile from '@/components/tiles/PDF'
import _get from 'lodash/get'

export default {
  name: 'EmailMessage',

  props: {
    communication: Object,
    isReadOnly: Boolean,
    step: Number
  },

  components: {
    MessageComposer,
    PDFModal,
    PDFTile
  },

  data() {
    return {
      visiblePage: 'Compose',
      showPreview: true,
      showAttachments: true,
      communicationID: 0,
      composedText: '',
      composedSubject: '',
      files: [],
      image: null,
      doc: null,
      previews: [],
      lGet: _get,
      activeTab: 0,
      documents: [],
      communicationAttachments: [],
      communicationAttachmentFile: null
    }
  },

  watch: {
    files() {
      this.updateAttachments()
    },
    async activeTab() {
      if (this.activeTab === 0) {
        this.visiblePage = 'Compose'
      } else if (this.activeTab === 1) {
        this.visiblePage = 'FinalPreview'
      } else if (this.activeTab === 2) {
        this.visiblePage = 'EmailAttachments'
        await this.getAttachments()
      }

      //auto-save
      if (this.activeTab === 1 || this.activeTab === 2) {
        if (this.emailMessage && this.emailSubject) {
          this.finalizeMessage(this.emailMessage, this.emailSubject)
        }
      }
    }
  },

  methods: {
    async handleImageAdded(file, Editor, cursorLocation) {
      console.debug('in handleImageAdded...' + cursorLocation)

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      try {
        console.debug('file=' + file)

        if (file !== undefined && file) {
          const payload = {
            communicationID: this.mailingCommunicationID,
            cursorPosition: cursorLocation,
            supportsMail: false,
            supportsEmail: true,
            description: this.communicationDescription,
            isAttachment: true
          }

          console.debug('payload addConversationAttachment=' + JSON.stringify(payload))

          await mailingCommunicationStore.dispatch('addCommunicationAttachment', {
            payload,
            done: async ({ detail }) => {
              if (detail) {
                console.debug('addCommunicationAttachment=' + JSON.stringify(detail))

                const payload = {
                  communicationAttachmentID: detail.communicationAttachmentID,
                  file: file
                }

                await mailingCommunicationStore
                  .dispatch('uploadCommunicationAttachmentDocument', {
                    payload: payload
                  })
                  .then(async returnedfile => {
                    if (returnedfile && detail) {
                      console.debug('returnedfile=' + JSON.stringify(returnedfile))

                      Editor.insertEmbed(
                        cursorLocation,
                        'image',
                        `${KMS_BACKEND}/MailingComponents/CommunicationAttachment/GetFilePublic?token=${detail.securityToken}`
                      )
                    }
                  })
              }
            }
          })
        }
      } catch (e) {
        setTimeout(() => loadingComponent.close(), 1000)
        notifyError(e)
      }

      setTimeout(() => loadingComponent.close(), 1000)
    },

    async deleteConfirmation() {
      this.$buefy.dialog.confirm({
        title: 'Delete Attachments',
        message: `Are you sure you want to <b>Delete your Attachments</b>?`,
        confirmText: 'Delete Attachments',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => await this.deleteAttachments()
      })
    },

    async deleteAttachments() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      if (this.communicationAttachments) {
        try {
          await mailingCommunicationStore.dispatch('deleteCommunicationAttachmentsByParentId', {
            communicationID: this.mailingCommunicationID,
            done: async () => {
              notifyMessage(`Successfully deleted the attachments.`)
              if (this.documents) this.documents.splice(0, this.documents.length)
              if (this.communicationAttachments)
                this.communicationAttachments(0, this.communicationAttachments.length)
              if (this.files) this.files.splice(0, this.files.length)
              if (this.previews) this.previews.splice(0, this.previews.length)
            }
          })
        } catch (e) {
          notifyError(e)
        }
      }

      setTimeout(() => loadingComponent.close(), 1000)
    },

    async updateAttachments() {
      console.debug('in updatedAttachments...')
      const attachments = this.files
      if (!Array.isArray(attachments)) {
        notifyProblem('A problem occurred and the attachments could not be uploaded.')
        return
      }

      ////////////////////////////////
      //  Store previews
      ////////////////////////////////

      this.previews = this.files.map(file => {
        return URL.createObjectURL(file)
      })

      console.debug('in updateAttachments...' + this.files.length)

      //this.$store.dispatch('conversation/modify', {
      //  previews: this.previews,
      //  attachments
      //})
    },

    async saveAttachments() {
      const id = this.mailingCommunicationID

      if (!this.files || this.files.length === 0) {
        notifyProblem(`Please select a file to upload. There are no files selected.`)
      }

      console.debug('in saveAttachments id=' + id)
      //Process one or more attachments

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      try {
        if (this.isDebug === true) console.debug('files=' + this.files)

        if (this.files && this.files.length > 0) {
          for (let a = 0; a < this.files.length; a++) {
            try {
              const file = this.files[a]
              console.debug('file=' + file)

              if (file !== undefined && file) {
                const payload = {
                  communicationID: this.mailingCommunicationID,
                  cursorPosition: this.cursorLocation,
                  supportsMail: false,
                  supportsEmail: true,
                  description: this.communicationDescription,
                  isAttachment: true
                }

                console.debug('payload addConversationAttachment=' + JSON.stringify(payload))

                await mailingCommunicationStore.dispatch('addCommunicationAttachment', {
                  payload,
                  done: async ({ detail }) => {
                    if (detail) {
                      console.debug('addCommunicationAttachment=' + JSON.stringify(detail))

                      const payload = {
                        communicationAttachmentID: detail.communicationAttachmentID,
                        file: file
                      }

                      await mailingCommunicationStore
                        .dispatch('uploadCommunicationAttachmentDocument', {
                          payload: payload
                        })
                        .then(async returnedfile => {
                          if (returnedfile && detail) {
                            console.debug('returnedfile=' + JSON.stringify(returnedfile))
                          }
                        })
                    }
                  }
                })
              }
            } catch (e) {
              setTimeout(() => loadingComponent.close(), 1000)
              notifyError(e)
            }
          }

          notifyMessage(`Successfully added your selected attachment(s).`)
        }
      } catch (e) {
        setTimeout(() => loadingComponent.close(), 1000)
        notifyError(e)
      }

      setTimeout(async () => await this.getAttachments(), 3000)

      setTimeout(() => loadingComponent.close(), 1000)
    },

    async openPDFModal(id) {
      if (this.documents) {
        for (let a = 0; a < this.documents.length; a++) {
          const document = this.documents[a]
          if (this.isDebug === true)
            console.debug('document id=' + id + ', document id=' + document.id)

          if (document.id === id) {
            this.$refs.pdfModal.open({
              src: this.documents[a].content
            })
            return
          }
        }
      }
    },

    async getAttachments() {
      if (this.files) this.files.splice(0, this.files.length)
      if (this.documents) this.documents.splice(0, this.documents.length)
      if (this.communicationAttachments)
        this.communicationAttachments.splice(0, this.communicationAttachments.length)

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      console.debug('in getAttachments...')
      //Need communications attachments list
      if (this.mailingCommunicationID > 0) {
        console.debug('in getAttachments if...')
        await mailingCommunicationStore
          .dispatch('getCommunicationAttachmentsByParentId', {
            communicationID: this.mailingCommunicationID
          })
          .then(({ list }) => {
            console.debug('in getAttachments before list')
            if (list) {
              console.debug('in getAttachments list')
              this.communicationAttachments = list

              Array.from(list).forEach(ca => {
                console.debug('in ca=' + JSON.stringify(ca))
                try {
                  console.debug('image or pdf............' + JSON.stringify(ca))

                  //documents
                  this.documents.push({
                    content: ca.baseString,
                    id: ca.communicationAttachmentID
                  })
                } catch (e) {
                  console.debug(e)
                }
              })
            }
          })
      }

      setTimeout(() => loadingComponent.close(), 1000)
    },

    async handleImageRemoved(file) {
      console.debug('in handleImageRemoved...')
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      const flatContents = JSON.stringify(file)
      const flatContentsSplit = flatContents.split('communicationAttachmentID=')
      const communicationAttachmentID = parseInt(
        flatContentsSplit[1] !== undefined && flatContentsSplit[1] ? flatContentsSplit[1] : 0
      )

      console.debug('communicationAttachmentID=' + communicationAttachmentID)

      if (communicationAttachmentID > 0) {
        try {
          await mailingCommunicationStore.dispatch('deleteCommunicationAttachment', {
            communicationAttachmentID,
            done: () => {}
          })
        } catch (e) {
          loadingComponent.close()
          console.debug('There was an issue deleting this communication attachment.' + e)
        }
      }

      loadingComponent.close()
    },

    processFinalPreview(content, subject) {
      console.debug('in processFinalPreview Email...' + content)
      this.$store.dispatch('communication/composedEmailMessage', {
        emailMessage: content
      })

      this.$store.dispatch('communication/saveEmailSubject', {
        emailSubject: subject
      })

      this.composedText = content
      this.composedSubject = subject
      this.visiblePage = 'FinalPreview'
    },

    async processAttachments() {
      console.debug('in processAttachments Email...')
      this.visiblePage = 'EmailAttachments'
      await this.getAttachments()

      console.debug('attachments=' + JSON.stringify(this.communicationAttachments))
    },

    async deleteDropFile(index) {
      this.files.splice(index, 1)
      this.previews.splice(index, 1)
    },

    async processSendTestEmail(content, emailSubject) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      if (emailSubject === undefined || !emailSubject) {
        notifyError('The email subject is required.')
        loadingComponent.close()
        return
      }

      if (content === undefined || !content) {
        notifyError('The email message is required.')
        loadingComponent.close()
        return
      }

      await mailingCommunicationStore.dispatch('sendEmailMessage', {
        hoaID: this.hoaId,
        subject: emailSubject,
        message: content,
        done: async ({ detail }) => {
          console.debug('detail=' + detail)
          if (detail) {
            notifyMessage(`Successfully sent a test email to ${this.authUser.email || ''}`)
          }
        }
      })

      loadingComponent.close()
    },

    processCompose() {
      this.visiblePage = 'Compose'
      this.loadFromState()
    },

    processEditMessage() {},

    async finalizeMessage(content, emailSubject) {
      console.debug('finalizeMessage...')

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      if (emailSubject === undefined || !emailSubject) {
        notifyError('The email subject is required.')
        loadingComponent.close()
        return
      }

      if (content === undefined || !content) {
        notifyError('The email message is required.')
        loadingComponent.close()
        return
      }

      if (content && content.length > 0) {
        this.$store.dispatch('communication/composedEmailMessage', {
          emailMessage: content
        })
        this.composedText = content

        this.$store.dispatch('communication/saveEmailSubject', {
          emailSubject: emailSubject
        })
        this.composedSubject = emailSubject

        const params = {
          communicationID: this.mailingCommunicationID,
          supportMailDelivery: this.supportMailDelivery,
          supportEmailDelivery: this.supportEmailDelivery,
          supportSMSDelivery: this.supportSMSDelivery,
          supportPushDelivery: this.supportPushDelivery,
          isLegalCommunication: this.isLegalCommunication,
          description: this.communicationDescription,
          mailFullDuplex: null,
          mailColor: null,
          htmlEmailContent: content,
          emailSubject: emailSubject,
          emailPriority: 'normal'
        }

        await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
          params,
          done: async ({ detail }) => {
            if (detail) {
              console.debug('update communication=' + JSON.stringify(detail))

              this.communicationID = detail.communicationID

              notifyMessage('This message has been saved for sending.')
            }
          }
        })

        loadingComponent.close()
      }
    },

    loadFromState() {
      setTimeout(() => {
        this.composedText = this.emailMessage || ''
        this.composedSubject = this.emailSubject || ''
        console.debug('loadFromState...' + this.composedText + ', subject=' + this.composedSubject)
      }, 4000)
    }
  },

  async mounted() {
    this.loadFromState()
  },

  computed: {
    ...mapState({
      ...mapGetters('user', ['authUser']),
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('communication', [
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingTypeID',
        'emailMessage',
        'emailSubject',
        'mailingCommunicationID',
        'communicationDescription',
        'isColor',
        'isFullDuplex'
      ])
    })
  }
}
</script>
<style lang="scss">
.uploader {
  .rectangle {
    width: 244px;
    height: 107px;
    margin: 13px 16px 11px 53px;
    padding: 18px 25px 8px 3px;
    border-radius: 4px;
    border: #979797;
  }
  .Drag-Drop-your-fil {
    width: 192px;
    height: 34px;
    margin: 7px 0 8px 4px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center !important;
    color: #838383;
  }

  .Drag-Drop-your-fil .text-style-1 {
    font-weight: bold;
    color: #6e7776;
  }

  img.Fill-1-Copy-11 {
    width: 24px;
    height: 30px;
    margin: 0 85px 7px 83px;
    object-fit: contain;
  }
}
</style>
